module.exports = __webpack_public_path__ + "static/img/hublogo.69090f3f.png";